'use client';

import dynamic from 'next/dynamic';
import { useSession } from 'next-auth/react';
import { useUser } from '@/lib/contexts/user-context';
import { useFeatureFlags } from '@/lib/providers/feature-flags-provider';

const ONBOARDING_FEATURE_FLAG = 'onboarding';

const IntercomMessengerLoader = dynamic(
  () =>
    import('./intercom-messenger-loader').then(
      (m) => m.IntercomMessengerLoader
    ),
  { ssr: false }
);

export function IntercomMessenger() {
  const { status } = useSession();
  const { user } = useUser();
  const { hasFeature, isLoading: featuresLoading } = useFeatureFlags();

  if (status !== 'authenticated' || !user) return null;
  if (featuresLoading) return null;
  if (!hasFeature(ONBOARDING_FEATURE_FLAG)) return null;

  return <IntercomMessengerLoader user={user} hasFeature={hasFeature} />;
}
